@if (isLoading) {
  <div class="flex justify-center items-center w-full h-full">
    <mat-spinner class="text-petrol-600"></mat-spinner>
  </div>
} @else {
  <ng-content></ng-content>
}
